import { Action } from '@ngrx/store';
import { Cart, CartStatus } from '../../shared/models/b2b/cart';
import { User } from '../../shared/models/b2b/user';
import { CartItemAdd } from '../../shared/models/b2b/cartItem';
import { Shipping } from '../../shared/models/b2b/shipping';
import { Checkout } from '../../shared/models/b2b/checkout';

export enum CartActionTypes {
    DO_PURCHASE = '[Cart] Do Purchase',
    DO_PURCHASE_OK = '[Cart] Do Purchase OK',
    DO_PURCHASE_KO = '[Cart] Do Purchase KO',
    DO_PULL = '[Cart] Do Pull',
    DO_PULL_OK = '[Cart] Do Pull OK',
    DO_PULL_KO = '[Cart] Do Pull KO',
    DO_PUSH = '[Cart] Do PUSH',
    DO_PUSH_MULTIPLE = '[Cart] DO_PUSH_MULTIPLE',
    DO_PUSH_OK = '[Cart] Do PUSH OK',
    DO_PUSH_KO = '[Cart] Do PUSH KO',
    DO_UPDATE = '[Cart] Do UPDATE',
    DO_UPDATE_OK = '[Cart] Do UPDATE OK',
    DO_UPDATE_KO = '[Cart] Do UPDATE KO',
    DO_CLEAR = '[Cart] Do Clear',
    DO_CLEAR_OK = '[Cart] Do Clear OK',
    DO_CLEAR_KO = '[Cart] Do Clear KO',
    DO_NEW = '[Cart] Do New',
    DO_NEW_OK = '[Cart] Do New OK',
    DO_NEW_KO = '[Cart] Do New KO',
    DO_NEW_FROM_FILE = '[Cart] Do New From File',
    DO_NEW_FROM_FILE_OK = '[Cart] New From File OK',
    DO_NEW_FROM_FILE_KO = '[Cart] New From File KO',
    DO_NEW_FROM_FAVOURITE = '[Cart] Do New From Favourite',
    DO_SET_FAVOURITE = '[Cart] Set Favourite',
    DO_SET_FAVOURITE_OK = '[Cart] Set Favourite OK',
    DO_SET_FAVOURITE_KO = '[Cart] Set Favourite KO',
    DO_CHANGE_NAME = '[Cart] Set Change Name',
    DO_CHANGE_NAME_OK = '[Cart] Set Change Name OK',
    DO_CHANGE_NAME_KO = '[Cart] Set Change Name KO',
    DO_VALIDATE_CART = '[Cart] Validate Cart',
    DO_VALIDATE_CART_OK = '[Cart] Validate Cart OK',
    DO_VALIDATE_CART_KO = '[Cart] Validate Cart KO',
    DO_SET_CART = '[Cart] Set Cart',
    DO_SET_CART_STATUS = '[Cart] Set Cart Status',
}

export class DoPurchase implements Action {
    readonly type = CartActionTypes.DO_PURCHASE;
    constructor() {}
}

export class DoPurchaseOK implements Action {
    readonly type = CartActionTypes.DO_PURCHASE_OK;
    constructor(public payload: any) {}
}

export class DoPurchaseKO implements Action {
    readonly type = CartActionTypes.DO_PURCHASE_KO;
    constructor(public payload: any) {}
}

export class DoPull implements Action {
    readonly type = CartActionTypes.DO_PULL;
    constructor(public payload: any) {}
}

export class DoPullOK implements Action {
    readonly type = CartActionTypes.DO_PULL_OK;
    constructor(public payload: any) {}
}

export class DoPullKO implements Action {
    readonly type = CartActionTypes.DO_PULL_KO;
    constructor(public payload: any) {}
}

export class DoPush implements Action {
    readonly type = CartActionTypes.DO_PUSH;
    constructor(
        public payload: {
            item: any;
            quantity: number;
        }
    ) {}
}

export class DoPushMultiple implements Action {
    readonly type = CartActionTypes.DO_PUSH_MULTIPLE;
    constructor(
        public payload: {
            items: CartItemAdd[];
        }
    ) {}
}

export class DoPushOK implements Action {
    readonly type = CartActionTypes.DO_PUSH_OK;
    constructor(public payload: any) {}
}

export class DoPushKO implements Action {
    readonly type = CartActionTypes.DO_PUSH_KO;
    constructor(public payload: any) {}
}

export class DoUpdate implements Action {
    readonly type = CartActionTypes.DO_UPDATE;
    constructor(
        public payload: {
            item: any;
            quantity?: number;
            price?: number;
            discount?: number;
            shipping?: Shipping;
            shippingSelected?: number;
            type: string;
        }
    ) {}
}

export class DoUpdateOK implements Action {
    readonly type = CartActionTypes.DO_UPDATE_OK;
    constructor(public payload: any) {}
}

export class DoUpdateKO implements Action {
    readonly type = CartActionTypes.DO_UPDATE_KO;
    constructor(public payload: any) {}
}

export class DoClear implements Action {
    readonly type = CartActionTypes.DO_CLEAR;
    constructor() {}
}
export class DoClearOK implements Action {
    readonly type = CartActionTypes.DO_CLEAR_OK;
    constructor() {}
}
export class DoClearKO implements Action {
    readonly type = CartActionTypes.DO_CLEAR_KO;
    constructor() {}
}

export class DoNew implements Action {
    readonly type = CartActionTypes.DO_NEW;
    constructor(public payload: any) {}
}

export class DoNewFromFile implements Action {
    readonly type = CartActionTypes.DO_NEW_FROM_FILE;
    constructor(public payload: any) {}
}

export class DoNewFromFileOK implements Action {
    readonly type = CartActionTypes.DO_NEW_FROM_FILE_OK;
    constructor(public payload: any) {}
}

export class DoNewFromFileKO implements Action {
    readonly type = CartActionTypes.DO_NEW_FROM_FILE_KO;
    constructor(public payload: any) {}
}

export class DoNewFromFavourite implements Action {
    readonly type = CartActionTypes.DO_NEW_FROM_FAVOURITE;
    constructor(public payload: any) {}
}

export class DoNewOK implements Action {
    readonly type = CartActionTypes.DO_NEW_OK;
    constructor(public payload: any) {}
}

export class DoNewKO implements Action {
    readonly type = CartActionTypes.DO_NEW_KO;
    constructor(public payload: any) {}
}

export class DoSetFavourite implements Action {
    readonly type = CartActionTypes.DO_SET_FAVOURITE;
    constructor() {}
}

export class DoSetFavouriteOK implements Action {
    readonly type = CartActionTypes.DO_SET_FAVOURITE_OK;
    constructor(public payload: any) {}
}

export class DoSetFavouriteKO implements Action {
    readonly type = CartActionTypes.DO_SET_FAVOURITE_KO;
    constructor(public payload: any) {}
}

export class DoChangeName implements Action {
    readonly type = CartActionTypes.DO_CHANGE_NAME;
    constructor(public payload: any) {}
}

export class DoChangeNameOK implements Action {
    readonly type = CartActionTypes.DO_CHANGE_NAME_OK;
    constructor(public payload: any) {}
}

export class DoChangeNameKO implements Action {
    readonly type = CartActionTypes.DO_CHANGE_NAME_KO;
    constructor(public payload: any) {}
}

export class DoSetCart implements Action {
    readonly type = CartActionTypes.DO_SET_CART;
    constructor(public payload: { cart: Cart }) {}
}

export class DoValidateCart implements Action {
    readonly type = CartActionTypes.DO_VALIDATE_CART;
    constructor(
        public payload: {
            user: User;
            cart: Cart;
            recalculate?: boolean;
            parts?: boolean;
            modParts?: boolean;
            checkout?: Checkout;
        }
    ) {}
}

export class DoValidateCartOK implements Action {
    readonly type = CartActionTypes.DO_VALIDATE_CART_OK;
    constructor(public payload: any) {}
}

export class DoValidateCartKO implements Action {
    readonly type = CartActionTypes.DO_VALIDATE_CART_KO;
    constructor(public payload: any) {}
}

export class DoSetCartStatus implements Action {
    readonly type = CartActionTypes.DO_SET_CART_STATUS;
    constructor(public payload: { cartStatus: CartStatus }) {}
}

export type CartActions =
    | DoPurchase
    | DoPurchaseOK
    | DoPurchaseKO
    // DoPull | DoPullOK | DoPullKO |
    | DoPush
    | DoPushOK
    | DoPushKO
    | DoClear
    | DoClearOK
    | DoClearKO
    | DoNew
    | DoNewOK
    | DoNewKO
    | DoNewFromFile
    | DoNewFromFileOK
    | DoNewFromFileKO
    | DoNewFromFavourite
    | DoSetFavourite
    | DoSetFavouriteOK
    | DoSetFavouriteKO
    | DoChangeName
    | DoChangeNameOK
    | DoChangeNameKO
    | DoValidateCart
    | DoValidateCartOK
    | DoValidateCartKO
    | DoSetCart
    | DoSetCartStatus;
